import "./index.css";
import { createBrowserRouter, RouterProvider } from "react-router-dom";

import Layout from "./Layout";
import Start from "./steps/Start";
import Goals from "./steps/Goals";
import Age from "./steps/Age";
import Usage from "./steps/Usage";
import Time from "./steps/Time";
import ReadingStats from "./steps/ReadingStats";
import TimeSaved from "./steps/TimeSaved";
import Topics from "./steps/Topics";
import ThankYou from "./steps/ThankYou";
import BookSuggestion from "./steps/BookSuggestion";
import Info from "./steps/Info";
import Loading from "./steps/Loading";
import LoadingResult from "./steps/LoadingResult";
import BookList from "./steps/BookList";
import Form from "./steps/Form";
import data from "../data.json";
import SelectChallenge from "./steps/SelectChallenge";
import SelectPlan from "./steps/SelectPlan";
import Landing from "./steps/Landing";

async function loader() {
  return data;
}

const router = createBrowserRouter([
  {
    path: "/:offerType?",
    element: <Layout />,
    loader: loader,
    children: [
      {
        index: true,
        element: <Start />,
      },
      {
        path: "goals",
        element: <Goals />,
      },
      {
        path: "age",
        element: <Age />,
      },
      {
        path: "usage",
        element: <Usage />,
      },
      {
        path: "time",
        element: <Time />,
      },
      {
        path: "reading-stats",
        element: <ReadingStats />,
      },
      {
        path: "time-saved",
        element: <TimeSaved />,
      },
      {
        path: "topics",
        element: <Topics />,
      },
      {
        path: "thank-you",
        element: <ThankYou />,
      },
      {
        path: "book-suggestion/:bookId",
        element: <BookSuggestion />,
      },
      {
        path: "info",
        element: <Info />,
      },
      {
        path: "loading",
        element: <Loading />,
      },
      {
        path: "loading-result",
        element: <LoadingResult />,
      },
      {
        path: "book-list",
        element: <BookList />,
      },
      {
        path: "form",
        element: <Form />,
      },
      {
        path: "select-challenge",
        element: <SelectChallenge />,
      },
      {
        path: "select-plan",
        element: <SelectPlan />,
      },
      {
        path: "landing",
        element: <Landing />,
      },
    ],
  },
]);

function App() {
  return <RouterProvider router={router} />;
}

export default App;
